import { createSingleEntityStore } from '@core/ngrx-legacy';

import { ReferralsAssignedJobTemplatesList } from './types';

const { actions, reducer, namespace } =
  createSingleEntityStore<ReferralsAssignedJobTemplatesList>()(`ReferralsAssignedJobTemplates`, {
    customActions: adapter => ({
      fetch: (
        state,
        payload: { id: number; searchParams: { q: string | null; page: number; limit: number } },
      ) => adapter.markAsPending(state),
    }),
  });

const ReferralsAssignedJobTemplatesActions = <Pick<typeof actions, 'fetch' | 'fetchSuccess'>>(
  actions
);

export {
  ReferralsAssignedJobTemplatesActions,
  reducer as ReferralsAssignedJobTemplatesReducer,
  namespace as ReferralsAssignedJobTemplatesNamespace,
};
